import { render, staticRenderFns } from "./IndicateursWidget.vue?vue&type=template&id=488a10dc"
import script from "./IndicateursWidget.vue?vue&type=script&lang=js"
export * from "./IndicateursWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports